import react, { useEffect } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
const FormularioC = ({
  toggleModalCambio,
  modalCambio,
  CambioEstado,
  clientes,
  wared,
  datosWared,
  oneData2
}) => {
  const { handleSubmit, reset } = useForm(),
    OnSubmit = (data, e) => {
      const json = {
        waredhouse: oneData2.waredhouse,
        estado: e.target.estado.value,
      };
      CambioEstado(json);
      reset();
    }



  useEffect(
    () => {
        console.log(oneData2)
    },[]
)



  return (
    <>
      <Modal show={modalCambio} size="lg">
        <Modal.Header>
          <h6>Cambiar Estado Warehouse</h6>
        </Modal.Header>
        <Form onSubmit={handleSubmit(OnSubmit)}>
          <Modal.Body>
            <Row>
              <Col>
              <h3>Cliente: {oneData2.nombreCliente}</h3>
              </Col>
              <Col>
              <h3>Warehouse: {oneData2.noWare}</h3>
              </Col>
            </Row>

        
            <br />
            <Row>
              <Col>
                <Form.Group>
                  <Row>
                    <Col>
                      <Form.Check
                        label="Bodega Miami"
                        name="estado"
                        inline
                        type="radio"
                        value={1}
                      ></Form.Check>
                    </Col>
                    <Col>
                      <Form.Check
                        label="En Recoleccion Miami-Gt"
                        name="estado"
                        inline
                        type="radio"
                        value={2}
                      ></Form.Check>
                    </Col>
                    <Col>
                      <Form.Check
                        label="En Transito Miami-Gt"
                        name="estado"
                        inline
                        type="radio"
                        value={3}
                      ></Form.Check>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Check
                        label="Ingreso a COMBEX GT"
                        name="estado"
                        inline
                        type="radio"
                        value={4}
                      ></Form.Check>
                    </Col>
                    <Col>
                      <Form.Check
                        label="Proceso Aduanal"
                        name="estado"
                        inline
                        type="radio"
                        value={5}
                      ></Form.Check>
                    </Col>
                    <Col>
                      <Form.Check
                        label="Liberado Para Entrega"
                        name="estado"
                        inline
                        type="radio"
                        value={6}
                      ></Form.Check>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Check
                        label="Ingreso a Bodega GT"
                        name="estado"
                        inline
                        type="radio"
                        value={7}
                      ></Form.Check>
                    </Col>
                    <Col>
                      <Form.Check
                        label="En Ruta de Entrega"
                        name="estado"
                        inline
                        type="radio"
                        value={8}
                      ></Form.Check>
                    </Col>
                    <Col>
                      <Form.Check
                        label="Retorno a Bodega"
                        name="estado"
                        inline
                        type="radio"
                        value={9}
                      ></Form.Check>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Col>
                        <Form.Check
                          label="Entregado"
                          name="estado"
                          inline
                          type="radio"
                          value={10}
                        ></Form.Check>
                      </Col>
                    </Col>
                  </Row>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => toggleModalCambio(0)}>
              Salir
            </Button>
            <Button variant="success" type="submit">
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default FormularioC;
